import { createContext } from "react";

import { DraftInvoiceGenerateHelper } from "./DraftInvoiceGenerateHelper.ts";

export const DraftInvoiceGenerateContext =
  createContext<DraftInvoiceGenerateHelper>({} as DraftInvoiceGenerateHelper);
